<p>This component is guarded. You can see this because you're signed-in. </p>